import { render, staticRenderFns } from "./crudSellersCalendar.vue?vue&type=template&id=4a79f60a&scoped=true&"
import script from "./crudSellersCalendar.vue?vue&type=script&lang=js&"
export * from "./crudSellersCalendar.vue?vue&type=script&lang=js&"
import style0 from "./crudSellersCalendar.vue?vue&type=style&index=0&id=4a79f60a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a79f60a",
  null
  
)

export default component.exports